import { ErrorOutline } from "@mui/icons-material";
import { useAccessGrant } from "./useAccessGrants";

interface GrantNameProps {
  grantId: string;
}

export default function GrantName({ grantId }: GrantNameProps) {
  const { data, error } = useAccessGrant(grantId);
  const grantName = data?.grants?.grant?.name;
  return error ? (
    <ErrorOutline color="secondary" />
  ) : (
    <div>{grantName || grantId}</div>
  );
}
